import React from 'react'

import SlideShow from '../generic/SlideShow'

import Aliens from './assets/posters/aliens.jpg'
import JurassicPark from './assets/posters/jurassic.jpg'
import Predator from './assets/posters/predator.jpg'
import IronMan from './assets/posters/ironman.jpg'
import ArtificialIntelligence from './assets/posters/ai_artificialintelligence_poster_org.jpg'
import Avatar from './assets/posters/avatar_poster_org Large.jpeg'
import AvengersEndgame from './assets/posters/avengers_endgame_poster_org Large.jpeg'
import Avp from './assets/posters/avp_poster_org.jpg'
import CowboysAndAliens from './assets/posters/cowboysandaliens_poster_alt.jpg'
import Deadpool from './assets/posters/deadpool.jpg'
import EvilDead2 from './assets/posters/evildead_2_poster_org.jpg'
import GalaxyQuest from './assets/posters/galaxyquest_poster_alt Large.jpeg'
import GodzillaKingOfTheMonsters from './assets/posters/godzilla_kingofthemonsters_poster_org Large.jpeg'
import Hellboy from './assets/posters/hellboy_poster_org.jpg'
import IndianaJones from './assets/posters/indianajones.jpg'
import KongSkullIsland from './assets/posters/kong_skullisland_poster_alt Large.jpeg'
import LakePlacid from './assets/posters/lakeplacid_poster_alt Large.jpeg'
import MenInBlack from './assets/posters/meninblack.jpg'
import Narnia from './assets/posters/narnia_poster_org.jpg'
import Prey from './assets/posters/prey_poster_org Large.jpeg'
import RealSteel from './assets/posters/realsteel_poster_org.jpg'
import SmallSoldiers from './assets/posters/smallsoldiers_poster_alt.jpg'
import Species from './assets/posters/species_poster_org.jpg'
import StarTrek from './assets/posters/startrek_poster_alt.jpg'
import Terminator2 from './assets/posters/terminator_2_poster_org.jpg'
import TheMandalorian from './assets/posters/the_mandalorian.jpeg'
import TheAbyss from './assets/posters/theabyss_poster_org Large.jpeg'
import TheAmazingSpiderman from './assets/posters/theamazing.jpg'
import TheHungerGames from './assets/posters/thehungergames.jpg'
import TheShapeOfWater from './assets/posters/theshapeofwater_poster_org.jpg'
import Zombieland from './assets/posters/zombieland_poster_org.jpg'

export const posters = [
  { title: 'A.I. Artificial Intelligence (2001)', src: ArtificialIntelligence },
  { title: 'Aliens (1986)', src: Aliens },
  { title: 'Avatar (2009)', src: Avatar },
  { title: 'Avengers: Endgame (2019)', src: AvengersEndgame },
  { title: 'Alien vs. Predator (2004)', src: Avp },
  { title: 'Cowboys & Aliens (2011)', src: CowboysAndAliens },
  { title: 'Deadpool (2016)', src: Deadpool },
  { title: 'Evil Dead 2 (1987)', src: EvilDead2 },
  { title: 'Galaxy Quest (1999)', src: GalaxyQuest },
  {
    title: 'Godzilla: King of the Monsters (2019)',
    src: GodzillaKingOfTheMonsters
  },
  { title: 'Hellboy (2004)', src: Hellboy },
  { title: 'Indiana Jones (1981)', src: IndianaJones },
  { title: 'Iron Man (2008)', src: IronMan },
  { title: 'Jurassic Park (1993)', src: JurassicPark },
  { title: 'Kong: Skull Island (2017)', src: KongSkullIsland },
  { title: 'Lake Placid (1999)', src: LakePlacid },
  { title: 'Men in Black (1997)', src: MenInBlack },
  { title: 'Narnia (2005)', src: Narnia },
  { title: 'Predator (1987)', src: Predator },
  { title: 'Prey (2022)', src: Prey },
  { title: 'Real Steel (2011)', src: RealSteel },
  { title: 'Small Soldiers (1998)', src: SmallSoldiers },
  { title: 'Species (1995)', src: Species },
  { title: 'Star Trek (2009)', src: StarTrek },
  { title: 'Terminator 2 (1991)', src: Terminator2 },
  { title: 'The Mandalorian (2019)', src: TheMandalorian },
  { title: 'The Abyss (1989)', src: TheAbyss },
  { title: 'The Amazing Spiderman (2012)', src: TheAmazingSpiderman },
  { title: 'The Hunger Games (2012)', src: TheHungerGames },
  { title: 'The Shape of Water (2017)', src: TheShapeOfWater },
  { title: 'Zombieland (2009)', src: Zombieland }
]

function Credits() {
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 5,
    speed: 1000,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  }
  return (
    <section id="Credits" className="about-us-instructors-credits wrapper">
      <SlideShow {...settings}>
        {posters.map((poster) => (
          <div className="movie-poster" key={poster.title}>
            <img
              src={poster.src}
              alt={poster.title}
              title={poster.title}
            />
          </div>
        ))}
      </SlideShow>
    </section>
  )
}

export default Credits
